import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector} from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import moment from 'moment/min/moment-with-locales';
import {  SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';

export default function AccountingExport() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  
  const settings = useSelector(state => state.settingsdata.settings);

  function formatAmount(value, decimal, country) {
    const number = parseFloat(value || 0);
    if (country === "Vietnam") {
      return number.toLocaleString("vi-VN", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    } else {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    }
  }


  const [data, setData] = useState([]);
  const bookinglistdata = useSelector(state => state.bookinglistdata);

  useEffect(()=>{
        if(bookinglistdata.bookings){

const updated = bookinglistdata.bookings.map(item => ({
      ...item,
      tripdateFormatted: moment(item.tripdate).format('lll')
    }));
            setData(updated);
        }


  },[bookinglistdata.bookings]);

  const [selectedRow, setSelectedRow] = useState(null);


  const columns =  [
    { title: ('Trip ID'), field: 'reference', render: rowData => rowData.reference , editable:'never'},
    { title: ('Trip Date'), field: 'tripdateFormatted', render: rowData => rowData.tripdateFormatted , editable:'never'},
    { title: ('Total Paid'), field: 'grandTotal', render: rowData => formatAmount((parseFloat(rowData.grandTotal)), settings.decimal, settings.country) , editable:'never'},
    { title: ('Driver Fare (Excl. GST)'), field: 'driverfareTotal', render: rowData => formatAmount((parseFloat(rowData.driverfareTotal)), settings.decimal, settings.country) , editable:'never'},
    { title: ('Zoomerrr Service Fee (Excl. GST)'), field: 'platformFee', render: rowData => formatAmount((parseFloat(rowData.platformFee)), settings.decimal, settings.country) , editable:'never'},
    { title: ('Total GST'), field: 'totalGST', render: rowData => formatAmount((parseFloat(rowData.totalGST)), settings.decimal, settings.country) , editable:'never'},
  ];


  return (
    bookinglistdata.loading? <CircularLoading/>:
    <ThemeProvider theme={theme}>
      <MaterialTable
        title={('ACCOUNTING LEDGER')}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        }}
        data={data}
        
        onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        options={{
          exportButton: true,
          rowStyle: (rowData) => ({
            backgroundColor:
              selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
          }),
          ...TableStyle()
        }}
        localization={localization(t)}
      />
    </ThemeProvider>
  );
}